"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DropdownIconItem = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _iconButton = require("../icon-button");

var _getClassesPropType = require("../../helpers/getClassesPropType");

var _useStyles = require("../../helpers/useStyles");

var _classnames = _interopRequireDefault(require("classnames"));

var _loadStyles = _interopRequireDefault(require("load-styles"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

(0, _loadStyles.default)(".ce14c1462{font-size:1rem;font-weight:400;line-height:1.125rem;color:var(--color-flomni-gray-90);cursor:pointer;display:flex;align-items:center}.ce14c1462:hover{opacity:.7}.c867ed8b7{padding-left:.75rem;max-width:calc(100% - 1.75rem);overflow-wrap:break-word;box-sizing:border-box}.ccad5dca1{color:var(--color-flomni-blue-70)}.ccad5dca1:hover{opacity:1}.c7cb7f65f{color:var(--color-flomni-gray-90);opacity:.4;cursor:default}.c7cb7f65f:hover{opacity:.4}");
var styles = {
  root: 'ce14c1462',
  item: 'c867ed8b7',
  '--active': 'ccad5dca1',
  '--disabled': 'c7cb7f65f'
};

var DropdownIconItem = function DropdownIconItem(props) {
  var onClick = props.onClick,
      children = props.children,
      Icon = props.Icon,
      classes = props.classes,
      disabled = props.disabled,
      active = props.active;
  var cn = (0, _useStyles.useStyles)(styles, classes);
  var onClickHandler = (0, _react.useCallback)(function () {
    if (disabled) return;
    onClick.apply(void 0, arguments);
  }, [disabled, onClick]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(cn.root, (0, _defineProperty2.default)({}, cn.active, active), (0, _defineProperty2.default)({}, cn.disabled, disabled)),
    onClick: onClickHandler
  }, /*#__PURE__*/_react.default.createElement(_iconButton.IconButton, {
    view: "block"
  }, /*#__PURE__*/_react.default.createElement(Icon, null)), /*#__PURE__*/_react.default.createElement("div", {
    className: cn.item
  }, children));
};

exports.DropdownIconItem = DropdownIconItem;
DropdownIconItem.propTypes = {
  /* component logic props */
  onClick: _propTypes.func,
  Icon: _propTypes.elementType.isRequired,
  children: _propTypes.node.isRequired,
  disabled: _propTypes.bool,
  active: _propTypes.bool,

  /* classes */
  classes: (0, _getClassesPropType.getClassesPropType)(styles)
};
DropdownIconItem.defaultProps = {
  onClick: function onClick() {},
  classes: {},
  disabled: false,
  active: false
};